import { httpRequest } from "../../http";
import type { Correction } from "@models/Discrepancy.model";

export class CommandRevokeCorrection {
  async run(correctionId: number): Promise<Correction> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/corrections/${correctionId}/revoke/`;
    return httpRequest<Correction>(url, { method: "POST" });
  }
}
